import initialState from '@/store/initial-state'

function filterFunction({ cubeFilter }, getters) {
  return (cube) => {
    if (cubeFilter.showOnlyProducers) {
      if (!cube.hasProduction) return false

      if (cubeFilter.showOnlyProducersWithCapacity) {
        if (cube.params.openConnectionsAvailable < 1) return false
        // We cannot receive energy from ourselves
        if (cube.params.nickName === getters.nickName) return false
        // If we are already connected there's no point in showing the cube
        if (cube.isProducer) return false
      }

      if (
        cubeFilter.energyType &&
        cubeFilter.energyType !== 'all' &&
        cubeFilter.energyType !== cube.productionType
      )
        return false

      const price = getters.producerPrices(cube.cubeName)
      if (price && price.currentPrice) {
        if (price.currentPrice < cubeFilter.priceMin / 100) return false
        if (price.currentPrice > cubeFilter.priceMax / 100) return false
      }
    }

    return true
  }
}

function numberOfActiveFilters(state) {
  const defaultState = initialState().cubeFilter
  const ignoredKeys = ['filterFunction', 'numberOfActiveFilters']
  let changes = 0

  for (const [key, value] of Object.entries(defaultState)) {
    if (ignoredKeys.includes(key)) continue
    // Unfortunately entry types are not stable as they move through the store, so we have to allow casting (!=) here
    if (state.cubeFilter[key] != value) changes++
  }

  return changes
}

export default { filterFunction, numberOfActiveFilters }
